module.exports = __webpack_public_path__ + "static/recorded-data-011b40b0aa33cecce44bfc5a685c741f.svg";